__turbopack_context__.v({
  "image": "image-module-scss-module__6VbxRq__image",
  "imageWrapper": "image-module-scss-module__6VbxRq__imageWrapper",
});
